import { render, staticRenderFns } from "./MilestoneTemplateListing.vue?vue&type=template&id=35dd0928"
import script from "./MilestoneTemplateListing.vue?vue&type=script&lang=js"
export * from "./MilestoneTemplateListing.vue?vue&type=script&lang=js"
import style0 from "./MilestoneTemplateListing.vue?vue&type=style&index=0&id=35dd0928&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports